import { render, staticRenderFns } from "./DashboardPageDetail.vue?vue&type=template&id=0a598dd0&scoped=true&"
import script from "./DashboardPageDetail.vue?vue&type=script&lang=js&"
export * from "./DashboardPageDetail.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPageDetail.vue?vue&type=style&index=0&id=0a598dd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a598dd0",
  null
  
)

export default component.exports